// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2rrKX","signatureBlock":"Footer_signatureBlock__gF1-k","signature":"Footer_signature__1g242"};